import { render, staticRenderFns } from "./PointCheck.vue?vue&type=template&id=13b1c3a0&scoped=true"
import script from "./PointCheck.vue?vue&type=script&lang=js"
export * from "./PointCheck.vue?vue&type=script&lang=js"
import style0 from "./PointCheck.vue?vue&type=style&index=0&id=13b1c3a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1c3a0",
  null
  
)

export default component.exports